/**
 * Partial mapping of result from ecdn10 agent call: kontiki/kontiki/cache/RetrieveAgentData
 */
/* eslint-disable @typescript-eslint/naming-convention */
export default class AgentData {
  blackout?: boolean;
  machine_name?: string;
  machine_user_guid?: string;
  node_id?: unknown;
  version?: string;
  live_timeout?: number;
  vod_timeout?: number;
  vod_optout?: boolean;

  constructor(obj?: AgentData) {
    this.blackout = obj && obj.blackout;
    this.machine_name = obj && obj.machine_name;
    this.machine_user_guid = obj && obj.machine_user_guid;
    this.node_id = obj && obj.node_id;
    this.version = obj && obj.version;
    this.live_timeout = obj && obj.live_timeout;
    this.vod_timeout = obj && obj.vod_timeout;
    this.vod_optout = obj && obj.vod_optout;
  }
}
